<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: 'لیست پرسنل', icon: 'account-group' }"
    hide-confirm
    max-width="1240"
    reloadable
    @close="resetFields"
    :key="$i18n.locale"
    @reload="handleReload"
  >
    <v-card class="pa-4" flat>
      <v-progress-linear v-show="loading" class="mb-2" indeterminate />
      
      <!-- هدر آمار و دکمه دانلود اکسل -->
      <v-card class="mx-auto pa-3 rounded-lg mb-4" outlined color="grey lighten-4" elevation="1">
        <v-row align="center" no-gutters>
          <v-col cols="12" sm="6" class="d-flex align-center">
            <span class="ml-1">تعداد کل پرسنل:</span>
            <strong>{{ use_lang(total) || "-" }}</strong>
          </v-col>

          <v-col cols="12" sm="6" class="text-left mt-2 mt-sm-0">
            <v-btn
              outlined
              class="btn-get-code rounded-lg font-weight-bold"
              :loading="downLoading"
              :disabled="downLoading || loading"
              @click="downloadExcel"
            >
              <v-icon left>mdi-file-excel-outline</v-icon>
              خروجی اکسل پرسنل
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <vue-table :data="data" :headers="employeeColumns" @change="onPagination">
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد در صفحه"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="4" md="5">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="جستجو (نام، کد ملی، شماره)"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="4">
              <v-select
                v-model="props.dir"
                :items="dirOptions"
                label="ترتیب نمایش"
                dense
                outlined
                hide-details
                class="rounded-lg"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{ use_lang(item.index + 1 + (data.current_page - 1) * data.per_page) }}
        </template>

        <template v-slot:fullname="{ item }">
          {{ item.name }} {{ item.family }}
        </template>

        <template v-slot:mobile="{ item }">
          {{ use_lang(item.mobile) }}
        </template>

        <template v-slot:national_code="{ item }">
          {{ use_lang(item.national_code) }}
        </template>

        <template v-slot:created_at="{ item }">
          {{ datetime(item.created_at, "datetime") }}
        </template>

      </vue-table>
    </v-card>
  </custom-popup>
</template>

<script>
export default {
  name: "EmployeeList",

  props: {
    value: Boolean,
    address: String,
  },

  data() {
    return {
      data: null,
      total: 0,
      employees: [],
      tableProps: {
        search: "",
        length: 15,
        column: "id",
        dir: "desc",
        page: 1,
      },
      loading: false,
      downLoading: false,

      dirOptions: [
        { text: "جدیدترین", value: "desc" },
        { text: "قدیمی‌ترین", value: "asc" },
      ],
    };
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
    employeeColumns() {
      return [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        { value: "personal_code", text: "کد پرسنلی", align: "center", sortable: true },
        { value: "fullname", text: "نام و نام خانوادگی", align: "center", sortable: false },
        { value: "national_code", text: "کد ملی", align: "center", sortable: false },
        { value: "mobile", text: "شماره موبایل", align: "center", sortable: false },
        { value: "department", text: "واحد / دپارتمان", align: "center", sortable: false },
        { value: "role", text: "سمت شغلی", align: "center", sortable: false },
        { value: "created_at", text: "تاریخ ثبت", align: "center", sortable: true },
      ];
    },
  },

  watch: {
    value(val) {
      if (val) this.fetch();
    },
  },

  methods: {
    handleReload() {
      this.fetch();
    },

    downloadExcel() {
      this.downLoading = true;
      const params = {
        search: this.tableProps.search || "",
        dir: this.tableProps.dir,
      };

      /* --- اتصال API واقعی (کامنت شده) ---
      this.$api.get(`/v1/attendance/employees/excel/${this.address || ''}`, { params })
        .then(({ data }) => {
          if (data.download_url) {
            const moment = require('moment-jalaali');
            const a = document.createElement('a');
            a.setAttribute('href', data.download_url);
            a.setAttribute('download', `employees_${moment().format('jYYYY-jMM-jDD_HH-mm-ss')}.xlsx`);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.$toast.success("فایل با موفقیت آماده و دانلود شد");
          }
        })
        .catch((err) => {
          console.error("خطا در دانلود اکسل:", err);
          this.$toast.error("خطا در ایجاد خروجی اکسل");
        })
        .finally(() => {
          this.downLoading = false;
        });
      */

      // شبیه‌سازی تستی
      setTimeout(() => {
        this.downLoading = false;
        this.$toast ? this.$toast.info("درخواست اکسل پرسنل ارسال شد") : console.log("Export employees", params);
      }, 1000);
    },

    fetch(props = this.tableProps) {
      this.loading = true;

      /* --- اتصال API واقعی (کامنت شده) ---
      this.$api.get(`/v1/attendance/employees/${this.address || ''}`, {
        params: {
          search: props.search || "",
          dir: props.dir,
          page: props.page,
          length: props.length,
        },
      })
      .then(({ data }) => {
        this.total = data.data.total;
        this.data = data.data;
        this.employees = data.data.data;
      })
      .catch((err) => {
        this.$toast.error("خطا در دریافت لیست پرسنل");
      })
      .finally(() => {
        this.loading = false;
      });
      */

      setTimeout(() => {
        this.data = {
          current_page: props.page,
          per_page: props.length,
          total: 0,
          data: [
            // { id: 1, personal_code: '1001', name: 'علی', family: 'احمدی', national_code: '1234567890', mobile: '09120000000', department: 'فنی', role: 'برنامه‌نویس', created_at: '2023-10-22T10:00:00Z' },
            // { id: 2, personal_code: '1002', name: 'سارا', family: 'محمدی', national_code: '0987654321', mobile: '09130000000', department: 'اداری', role: 'منشی', created_at: '2023-10-21T09:30:00Z' }
          ]
        };
        this.total = this.data.total;
        this.loading = false;
      }, 600);
    },

    onPagination(e) {
      const changed =
        e.page !== this.tableProps.page ||
        e.length !== this.tableProps.length ||
        e.search !== this.tableProps.search ||
        e.dir !== this.tableProps.dir;

      if (changed) {
        Object.assign(this.tableProps, e);
        this.fetch();
      }
    },

    resetFields() {
      this.employees = [];
      this.total = 0;
      this.tableProps = { search: "", length: 15, column: "id", dir: "desc", page: 1 };
    },
  },
};
</script>
